// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { useEffect, useState } from 'react'
// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import { EllipsisTextPopup } from 'ui_kit_qmd'
import { isActiveEllipsisCheck } from '../../../utils/common'
import './AccountsSettingsInfoRow.scss'
import passwordEllipsIcon from '../../../images/common/password-ellipse.png'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const AccountsSettingsInfoRow = ({ className = '', style, keyValue, value, isTheLastItem, type }) => {
  const [isValueMouseOver, setIsValueMouseOver] = useState(false)
  const [isValueEllipsis, setIsValueEllipsis] = useState(false)
  const [keyValueWidth, setKeyValueWidth] = useState(0)

  useEffect(() => {
    // @ts-expect-error TS2531 -- MIGRATION: not approved, fix when encountered
    const keyValueElementWidth = document.getElementById(
      `account-settings-info-row-key-${keyValue}-${value}`,
    ).offsetWidth
    setKeyValueWidth(keyValueElementWidth)

    const timer = setInterval(() => {
      // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
      isActiveEllipsisCheck(`account-settings-info-row-value-${keyValue}-${value}`, setIsValueEllipsis)
    }, 1000)

    return () => clearInterval(timer)
  }, [value])

  const toggleMouseOver = () => {
    setIsValueMouseOver(true)
  }

  const toggleMouseOut = () => {
    setIsValueMouseOver(false)
  }

  return (
    <div
      className={`accounts-settings-info-row-main-wrapper ${
        isTheLastItem ? 'accounts-settings-info-row-last-item' : ''
      } ${className}`}
      style={style}>
      <div
        id={`account-settings-info-row-key-${keyValue}-${value}`}
        className='account-settings-section-text account-settings-section-info-text accounts-settings-info-row-key-value'>
        {keyValue}
      </div>
      <div
        className='accounts-settings-info-row-value-wrapper'
        style={{
          maxWidth: `calc(100% - ${keyValueWidth}px)`,
          marginLeft: type === 'password' ? 16 : 7,
        }}>
        {type === 'password' ?
          <>
            {/*
             // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered */}
            {value.split('').map((letter) => (
              <img
                key={letter}
                className='accounts-settings-info-row-password-ellips'
                src={passwordEllipsIcon}
                alt='ellips'
              />
            ))}
          </>
        : <div
            role='presentation'
            id={`account-settings-info-row-value-${keyValue}-${value}`}
            className='account-settings-section-text account-settings-section-info-text accounts-settings-info-row-value'
            onMouseOver={toggleMouseOver}
            onFocus={toggleMouseOver}
            onMouseOut={toggleMouseOut}
            onBlur={toggleMouseOut}>
            <div />
            {value}
          </div>
        }
        {isValueMouseOver && isValueEllipsis ?
          <EllipsisTextPopup>{value}</EllipsisTextPopup>
        : null}
      </div>
    </div>
  )
}
